import Typography from "components/typography";
import React, { ReactElement } from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";

interface IProps {
  coverImg: string;
  name: string;
  artist: string;
  type: string;
  uploadDate: string;
  relaseDate: string;
  OGReleaseDate?: string;
}
const TrackDetails = ({
  coverImg,
  name,
  artist,
  type,
  uploadDate,
  relaseDate,
  OGReleaseDate
}: IProps) => {
  return (
    <Container>
      <CoverImageContainer src={coverImg} alt="" />
      <TextDetails>
        <Typography size="s" mb="0.8">
          {type}
        </Typography>
        <Typography size="5.6rem" weight="bold" mb="1" m_size="4xl">
          {name}
        </Typography>
        <Typography weight="medium" size="xl" mb="3.2" m_size="lg">
          {artist}
        </Typography>
        <ReleaseScheduleGrid>
          <Typography size="xs" weight="semibold">
            UPLOADED
          </Typography>
          <Typography size="xs" weight="semibold">
            RELEASE DATE
          </Typography>
          <Typography size="xs" weight="semibold">
            ORIGINAL RELEASE DATE
          </Typography>
          <Typography size="s" color={Colors.grey300}>
            {uploadDate}
          </Typography>
          <Typography size="s" color={Colors.grey300}>
            {relaseDate}
          </Typography>
          <Typography size="s" color={Colors.grey300}>
            {OGReleaseDate ? OGReleaseDate : "N/A"}
          </Typography>
        </ReleaseScheduleGrid>
      </TextDetails>
    </Container>
  );
};

export default TrackDetails;

const Container = styled.div`
  margin-top: 3.2rem;
  width: 100%;
  display: flex;
  align-items: end;
  @media only screen and (max-width: 769px) {
    flex-direction: column;
    align-items: center;
  }
`;

const CoverImageContainer = styled.img`
  width: 26.4rem;
  height: 26.4rem;
  border-radius: 7px;
  margin-right: 1.6rem;
  @media only screen and (max-width: 769px) {
    margin-bottom: 1.6rem;
    margin-right: 0;
  }
`;

const TextDetails = styled.div`
  color: white;
  @media only screen and (max-width: 769px) {
    text-align: center;
  }
`;

const ReleaseScheduleGrid = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  grid-column-gap: 1.6rem;
  grid-row-gap: 0.4rem;
  @media only screen and (max-width: 769px) {
    text-align: left;
    width: 100%;
    justify-items: space-between;
  }
`;
